module.exports = __webpack_public_path__ + "media/images/image-card-826d9cfe66e1e481cb94327ce9ff4a51.svg";